import { Controller } from "@hotwired/stimulus"

// Copia um texto (link da vitrine / código de rastreio) pra área de transferência.
export default class extends Controller {
  static targets = ["source", "label"]
  static values = { text: String }

  async copy() {
    const text = this.hasTextValue && this.textValue
      ? this.textValue
      : (this.hasSourceTarget ? this.sourceTarget.value || this.sourceTarget.textContent : "")
    try {
      await navigator.clipboard.writeText(text.trim())
      this.flash("Copiado! ✓")
    } catch (_e) {
      this.flash("Copie manualmente")
    }
  }

  flash(msg) {
    if (!this.hasLabelTarget) return
    const original = this.labelTarget.textContent
    this.labelTarget.textContent = msg
    setTimeout(() => { this.labelTarget.textContent = original }, 1600)
  }
}
